/**
 * Hook for plans configuration
 */

import { useState, useEffect } from "react";
import { PlansConfig } from "../types";
import { subscribePlansConfig } from "../services/stripeService";

export function usePlansConfig() {
  const [plansConfig, setPlansConfig] = useState<PlansConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error] = useState<Error | null>(null);

  useEffect(() => {
    setLoading(true);

    const unsubscribe = subscribePlansConfig((config) => {
      setPlansConfig(config);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return { plansConfig, loading, error };
}
